import { FileAudio, Trash2 } from "lucide-react";

interface DeleteMutation {
  isPending: boolean;
  mutate: (args: { data: { index: number } }) => void;
}

interface VoiceSampleListProps {
  audioTranscripts: string[];
  deleteMutation: DeleteMutation;
}

function countWords(text: string): number {
  return text.trim().split(/\s+/).filter(Boolean).length;
}

export function VoiceSampleList({ audioTranscripts, deleteMutation }: VoiceSampleListProps) {
  if (audioTranscripts.length === 0) return null;

  return (
    <div className="space-y-3">
      <h3 className="text-sm font-medium text-muted-foreground">Audio Transcripts ({audioTranscripts.length})</h3>
      {audioTranscripts.map((transcript, idx) => {
        const wc = countWords(transcript);
        const isShort = wc < 80;
        return (
          <div key={idx} className="flex items-start gap-3 p-4 bg-card rounded-xl border border-border group">
            <FileAudio className="w-5 h-5 text-primary mt-0.5 shrink-0" />
            <div className="flex-1 min-w-0">
              <p className="text-sm text-foreground line-clamp-2">{transcript}</p>
              <span
                data-testid={`audio-word-count-${idx}`}
                className={`inline-block mt-1 text-xs px-1.5 py-0.5 rounded font-medium ${isShort ? "bg-amber-500/15 text-amber-400" : "text-muted-foreground"}`}
              >
                {wc} words{isShort ? " — Add more" : ""}
              </span>
            </div>
            <button
              onClick={() => deleteMutation.mutate({ data: { index: idx } })}
              className="opacity-0 group-hover:opacity-100 transition-opacity text-muted-foreground hover:text-destructive p-1"
              disabled={deleteMutation.isPending}
              aria-label="Delete voice sample"
            >
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
